import { SUPPORTED_LANGUAGES } from "../../common/constants";

export enum PreferencesActions {
  SET_LANGUAGE = "SET_LANGUAGE",
  TOGGLE_THEME = "TOGGLE_THEME",
}

export interface ISetLanguage {
  type: PreferencesActions.SET_LANGUAGE;
  language: SUPPORTED_LANGUAGES;
}

export interface IToggleTheme {
  type: PreferencesActions.TOGGLE_THEME;
}

export function setLanguage(language: SUPPORTED_LANGUAGES): ISetLanguage {
  return {
    type: PreferencesActions.SET_LANGUAGE,
    language,
  };
}

export function toggleTheme(): IToggleTheme {
  return {
    type: PreferencesActions.TOGGLE_THEME,
  };
}

export type PreferencesAction = ISetLanguage | IToggleTheme;
